

































import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import downIcon from '@/assets/icons/down.svg';

@Component({
  name: 'Dropdown',
})
/**
 * @vuese
 * @group Atomic/Organisms
 * dropdown
 */
export default class Dropdown extends Vue {
  // [Prop]
  @Prop({ type: Array, default: [], required: true }) readonly items!: string[];
  @Prop({ type: String, default: '' }) readonly placeholder!: string[];

  @Model('selectedChanged', { type: String, default: '' }) selectedItem!: string;

  // [Data]
  downIcon: string = downIcon;
  showSelection: boolean = false;

  // [Life cycle]
  mounted() {
    const outsideClickEvent = (e: Event) => {
      if (!this.$el.contains(e.target! as Node) && this.showSelection) {
        this.showSelection = false;
      }
    }

    document.addEventListener('click', outsideClickEvent);
  }

  // [Methods]
  selectItem(item: string) {
    this.showSelection = false;
    this.$emit('selectedChanged', item);
  }
}
